import type { ComponentProps } from 'react';

type Props = ComponentProps<'form'> & React.PropsWithChildren;

export const Form = ({ children, ...rest }: Props) => {
  return (
    <form noValidate {...rest}>
      {children}
    </form>
  );
};
